export type ProcessingStatus =
  | "awaiting_upload"
  | "uploaded"
  | "processing"
  | "processed"
  | "unprocessable"
  | "failed"
  | "expired";

export const REPROCESSABLE_STATUSES: ProcessingStatus[] = [
  "processed",
  "uploaded",
  "unprocessable",
  "failed",
];

export const DOWNLOADABLE_STATUSES: ProcessingStatus[] = [
  "processed",
  "processing",
  "unprocessable",
  "uploaded",
];

export interface PrivateDocument {
  created_by: string;
  created_on: number;
  file_extension: string;
  id: string;
  status: ProcessingStatus;
  title: string;
  updated_by: string;
  updated_on: number;
}

export interface DownloadDocumentLink {
  url: string;
  id: string;
}

export interface DocumentAnswer {
  answer: string;
  documents: PrivateDocument[];
}

export interface PrivateDocumentResponse {
  items: PrivateDocument[];
  page: number;
  page_size: number;
  total: number;
}
